module.exports = __webpack_public_path__ + "static/img/aside-ai.77b5016b.png";